/* RSI v2 · Opplevelser – logikk fra Claude Design. Krever rsi-dc.js. */

class RSIP_opplevelser extends DCLogic {
  renderVals() {
    
    return {};
  }
}

window.RSIP_opplevelser = RSIP_opplevelser;
